<template>
    <div class="global-upload-progress-container" v-if="showProgressPanel">
        <div class="global-upload-progress-header">
          Uploading files
          <span>Please do not refresh the page</span>
        </div>
        <div class="global-upload-progress-list">
          <div class="global-upload-progress-item" v-for="upload in uploads" :key="upload.id">
            <div class="global-upload-progress-item-header">
              {{ upload.fileName }}
            </div>
            <v-progress-linear
                rounded
                background-color="#E8EDFC"
                v-model="upload.progress"
                color="#5B7EDB"
                height="25"
                style="pointer-events: none"
            >
                <span class="progress-indicator">{{ Math.ceil(upload.progress) }}%</span>
            </v-progress-linear>
          </div>
        </div>
      </div>
  </template>
  
  <script>
  import { mapState } from 'vuex';
  
  export default {
    computed: {
      ...mapState(['globalUploadProgress']),
      showProgressPanel: {
        get() {
          return this.globalUploadProgress.isUploading;
        },
        set(value) {
          // Handle close if needed
        }
      },
      uploads() {
        return this.globalUploadProgress.uploads;
      }
    }
  };
  </script>

  <style scoped>

  .global-upload-progress-container{
    border-radius: 12px;
    background: #FFF;
    /* Shadow- L1 */
    box-shadow: 0 0 8px 0 rgba(102, 102, 102, 0.15);
    z-index: 100;
    position: fixed;
    bottom: 5%;
    right: 2%;
    width: 523px;
  }
  .global-upload-progress-header{
    display: flex;
    padding: 16px 20px;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
    border-bottom: 1px solid var(--Neutrals-200, #EDEDED);
    color: var(--Neutrals-600, #4C4C4C);
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
  .global-upload-progress-header span{
    color: var(--Neutrals-400, #999);
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%; /* 21px */
  }
    .global-upload-progress-list{
        display: flex;
        padding: 16px 24px 20px 24px;
        flex-direction: column;
        align-items: flex-start;
        gap: 12px;
        align-self: stretch;
    }
    .global-upload-progress-item{
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
        color: var(--Neutrals-600, #4C4C4C);
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 150%; /* 21px */
        padding-bottom: 12px;
        border-bottom: 1px solid var(--Neutrals-200, #EDEDED);
        width: 100%;
    }
    .global-upload-progress-item:last-child{
        border-bottom: none;
    }
    .progress-indicator{
        color: var(--Neutrals-White, #FFF);
        font-family: Inter;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: 150%; /* 18px */
        position: absolute;
        left: 2%;
    }
</style>